export default {
  functionKey: "ESTVIDE",
  title: "ESTVIDE",
  group: "Organisation",
  origin: [],
  target: [],
  description: "Retourne true si la cellule est vide.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = (${origin} === '' || ${origin} === null || ${origin} === undefined);`;
    return { displayCode: code, safeCode: code };
  }
}
